import React from 'react'
import { IconButton } from '@mui/material'
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt'
const ThumbsupButton = ({ isApproving, onApprove, size = 24 }) => {
  return (
    <>
      <IconButton size="small" disabled={isApproving} onClick={onApprove} name="isApproved">
        <ThumbUpOffAltIcon
          sx={{
            height: size ?? 24,
            width: size ?? 24,
            color: 'rgb(5, 190, 113)',
          }}
        />
      </IconButton>
    </>
  )
}

export default ThumbsupButton
